/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type {
  CreateEncounterErrorResponse,
  CreateEncounterRequest,
  CreateEncounterResponse,
} from './api.schemas';

import { api } from '../util/http';

export const createEncounters = (
  createEncounterRequest: CreateEncounterRequest,
  signal?: AbortSignal,
) => {
  return api<CreateEncounterResponse>({
    url: `/api/encounters`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createEncounterRequest,
    signal,
  });
};

export const getCreateEncountersMutationOptions = <
  TError = CreateEncounterErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEncounters>>,
    TError,
    { data: CreateEncounterRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createEncounters>>,
  TError,
  { data: CreateEncounterRequest },
  TContext
> => {
  const mutationKey = ['createEncounters'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createEncounters>>,
    { data: CreateEncounterRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createEncounters(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateEncountersMutationResult = NonNullable<
  Awaited<ReturnType<typeof createEncounters>>
>;
export type CreateEncountersMutationBody = CreateEncounterRequest;
export type CreateEncountersMutationError = CreateEncounterErrorResponse;

export const useCreateEncounters = <TError = CreateEncounterErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createEncounters>>,
      TError,
      { data: CreateEncounterRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createEncounters>>,
  TError,
  { data: CreateEncounterRequest },
  TContext
> => {
  const mutationOptions = getCreateEncountersMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
